import httpClient from 'shared/utils/http-client'
import { EditablePaymentSettings } from 'modules/profile/payment/types/payment-settings-interface'

export const PAYMENT_SETTINGS_API = '/api/dashboard/customer/settings/payment-page'

export const updatePaymentSettings = (data: EditablePaymentSettings) =>
  httpClient.put(PAYMENT_SETTINGS_API, data)
